import React, { useEffect, useRef, useState } from 'react'
import { Container, FormControl, Image, Nav, Navbar, NavDropdown, ToastContainer } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function LandingPageHeader() {
   
      const logo = useRef();
      // const [activeMenu, setActiveMenu] = useState(null);
      const [isScrolled, setIsScrolled] = useState(false);
      const [os, setOS] = useState(null);
      const [inputValue, setInputValue] = useState(null);
      // const [searchvalue, setSearchValue] = useState(null);
      useEffect(() => {
        const uOS = getOS();
        setOS(uOS)
        console.log(uOS);
        const handleScroll = () => {
          const offset = window.scrollY;
          setIsScrolled(offset > 50);
          if (offset > 50)
            logo.current.src = `${process.env.PUBLIC_URL}/logo/dastaan_logo.jpg`
          else
            logo.current.src = `${process.env.PUBLIC_URL}/logo/dastaan_logo.jpg`
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);
    
      useEffect(() =>{
     
      },[inputValue,setInputValue])
      const getOS = () => {
        const userAgent = window.navigator.userAgent;
        const platform = window.navigator.platform;
        const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
        const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
        const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
        let os = null;
        if (macosPlatforms.includes(platform)) {
          os = 'Mac OS';
        } else if (iosPlatforms.includes(platform)) {
          os = 'iOS';
        } else if (windowsPlatforms.includes(platform)) {
          os = 'Windows';
        } else if (/Android/.test(userAgent)) {
          os = 'Android';
        } else if (!os && /Linux/.test(platform)) {
          os = 'Linux';
        }
        return os;
      };
      const user_id = localStorage.getItem('dastaan__user_id');
      // setUserPlansStatus(user_plan);
      let menu;
      if (user_id == null) {
        menu = <Link className={`nav-link mr-auto p-2`} to="/login">
          <Nav className='nav-link'>Login</Nav>
        </Link>
      } else {
        const userLogOut = () => {
          localStorage.clear(); // remove all
          window.location.reload();
        }
        menu = <>
        {/* <span className='user-profile-name'>{localStorage.getItem('dastaan__name')}</span> */}
          <NavDropdown className={`mr-auto text-white ml-1`}
            title={
              <Image
                src={`${process.env.PUBLIC_URL}/logo/profile_placeholder.gif`}
                className="user-profile-image" roundedCircle 
                style={{
                  height:"40px",
                  width:"40px"
                }}
                />}
              /* <Image
                src={localStorage.getItem('user_image') !== ''
                  ? localStorage.getItem('user_image') : 'https://cdn.dribbble.com/users/1123508/screenshots/4602728/gif-final.gif'}
                className="user-profile-image" roundedCircle />} */
            id="basic-nav-dropdown"
          >
            <Link to="/profile" className='dropdown-item text-white'>Profile</Link>
            <Link to="/plans" className='dropdown-item text-white'>Plan</Link>
            {/* <Link to="/plans" className='dropdown-item text-white'>Transactions</Link> */}
            <Link to="/my-watchlist" className='dropdown-item text-white'>My Watchlist</Link>
            <NavDropdown.Divider />
            <NavDropdown.Item onClick={userLogOut}>
              Logout
            </NavDropdown.Item>
          </NavDropdown>
        </>
      }
    
   
      return (
        <>
          <Navbar expand="lg" className={isScrolled ? 'navbar-scrolled' : 'navbar-transparent'} bg="dark" data-bs-theme="dark"
            fixed='top'>
            <Container>
              <Link to="/" className='p-2'>
                <Nav >
                  {/* <span className='logo'>{process.env.PUBLIC_URL}/logo/dastaan_logo.jpg</span> */}
                  <Image ref={logo} src={os === 'Android' ? 'D' : `${process.env.PUBLIC_URL}/logo/dastaan_logo.jpg`} className='logo' alt="logo" title="Dastaan" />
                </Nav>
              </Link>
              <FormControl
                style={{ width: "40%" }}
                type='text'
                value={inputValue}
                // onClick={handleSearch}
                // onBlur={handleSearch}
               
                className='search-bar'
                placeholder='Search'
              />
             
            </Container>
          </Navbar>
          <ToastContainer />
        </>
      )
}

export default LandingPageHeader